import { employeeStatusOptions } from 'modules/core/components/EmployeeMultiFilters/commonOptions'
import employeeStatuses from 'modules/core/components/EmployeeMultiFilters/hooks/utils/employeeStatuses'
import {
  alertsOptions,
  clockinStatusOptions,
  legalEntityOptions,
  locationOptions,
  teamOptions,
} from 'modules/core/components/MultiFilters/commonOptions'
import type { FilterOption } from 'modules/core/components/MultiFilters/types'
import i18n from 'modules/core/lib/i18n'

const filterFields = async (
  showRealTimeAttendance = false,
  canSendEmailReminder = false,
  hasTimeTrackingInconsistencies = false
): Promise<FilterOption[]> => {
  let employeeStatusesFiltered = await employeeStatusOptions()
  const showClockInFilter = canSendEmailReminder && !!showRealTimeAttendance

  if (!!showRealTimeAttendance) {
    const awayKey = employeeStatusesFiltered.find((es) => es.value === employeeStatuses.away)
    if (!!awayKey) awayKey.label = i18n.t('employees.on_leave')

    employeeStatusesFiltered = employeeStatusesFiltered.filter(
      (es) => es.value !== employeeStatuses.clockIn && es.value !== employeeStatuses.onBreak
    )
  }

  const fieldsOptions: FilterOption[] = [
    {
      label: i18n.t('filters.multi_filters.employee_status'),
      value: 'employee_status',
      type: 'equal_choice',
      options: employeeStatusesFiltered,
    },
    {
      label: i18n.t('filters.multi_filters.employee'),
      value: 'employee_name',
      type: 'string',
    },
    {
      label: i18n.t('filters.multi_filters.location'),
      value: 'location',
      type: 'single_choice',
      options: await locationOptions(),
    },
    {
      label: i18n.t('filters.multi_filters.team'),
      value: 'team',
      type: 'single_choice',
      options: await teamOptions(),
    },
    {
      label: i18n.t('filters.multi_filters.legal_entity'),
      value: 'legal_entity',
      type: 'single_choice',
      options: await legalEntityOptions(),
    },
  ]

  if (showClockInFilter) {
    fieldsOptions.push({
      label: i18n.t('filters.multi_filters.clockin_status'),
      value: 'clockin_status',
      type: 'equal_choice',
      options: await clockinStatusOptions(),
    })
  }

  if (hasTimeTrackingInconsistencies) {
    fieldsOptions.push({
      label: i18n.t('filters.multi_filters.alerts.title'),
      value: 'alerts',
      type: 'equal_choice',
      options: await alertsOptions(),
    })
  }

  return fieldsOptions
}

export default filterFields
